import { type Session } from '@ory/client-fetch';

type PublicMetadata = {
  emailVerificationRequired?: boolean;
};

function identityPublicMetadata(session: Session): PublicMetadata {
  return (session.identity?.metadata_public ?? {}) as PublicMetadata;
}

export function isEmailVerified(session: Session): boolean {
  const email = session.identity?.traits?.email as string | undefined;
  return (session.identity?.verifiable_addresses ?? []).some(
    (address) => address.via === 'email' && address.verified && (!email || address.value === email)
  );
}

export function signedInWithPassword(session: Session): boolean {
  return (session.authentication_methods ?? []).some((method) => method.method === 'password');
}

export function mustVerifyEmail(session: Session): boolean {
  if (isEmailVerified(session)) {
    return false;
  }
  return identityPublicMetadata(session).emailVerificationRequired === true;
}
